// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SLI$LiveRoom from "../../bindings/SLI.bs.js";
import * as ReactI18next from "react-i18next";
import * as Config$LiveRoom from "../../../Config.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "../PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Notification$LiveRoom from "../Notification.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SelectAccount$LiveRoom from "../SelectAccount.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Icons_Component$LiveRoom from "../Icons_Component.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as Tokens from "@sothebys/sterling/tokens";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../AuctionRoomSharedContacts.bs.js";
import * as Utils_AutochargeRestriction$LiveRoom from "../../Utils/Utils_AutochargeRestriction.bs.js";

var modalContainer = Curry._1(Css.style, {
      hd: Css.marginBottom(Css.px(16)),
      tl: {
        hd: Css.important(Css.paddingLeft(Css.px(40))),
        tl: {
          hd: Css.important(Css.paddingRight(Css.px(40))),
          tl: {
            hd: Css.important(Css.display(Css.flexBox)),
            tl: {
              hd: Css.flexDirection(Css.column),
              tl: {
                hd: Css.alignItems(Css.center),
                tl: {
                  hd: Css.important(Css.justifyContent(Css.unset)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var subHeader = Curry._1(Css.style, {
      hd: Css.fontFamily({
            NAME: "custom",
            VAL: Tokens.FontFamily.bentonSans
          }),
      tl: {
        hd: Css.fontSize(Css.px(16)),
        tl: {
          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
          tl: {
            hd: Css.marginTop(Css.px(16)),
            tl: {
              hd: Css.whiteSpace("preWrap"),
              tl: {
                hd: Css.fontWeight({
                      NAME: "num",
                      VAL: StyleConstants$LiveRoom.book
                    }),
                tl: {
                  hd: Css.lineHeight(Css.px(28)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

function AuctionEnrollmentModal$RestrictedAuctionNotification(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.height("auto"),
                    tl: {
                      hd: Css.maxWidth(Css.px(450)),
                      tl: {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("row"),
                          tl: {
                            hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag)),
                            tl: {
                              hd: Css.marginBottom(Css.px(6)),
                              tl: {
                                hd: Css.paddingTop(Css.px(8)),
                                tl: {
                                  hd: Css.paddingBottom(Css.px(8)),
                                  tl: {
                                    hd: Css.paddingRight(Css.px(16)),
                                    tl: {
                                      hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                            hd: Css.width(Css.pct(100)),
                                            tl: {
                                              hd: Css.maxWidth(Css.pct(100)),
                                              tl: /* [] */0
                                            }
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.width(Css.px(100)),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.justifyContent("center"),
                            tl: {
                              hd: Css.alignItems("center"),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(Icons_Component$LiveRoom.InfoCircle.make, {
                      width: "20",
                      height: "20"
                    })), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "restrictedAuctionModalText"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("p", {
                        className: Curry._1(Css.style, {
                              hd: Css.fontFamily({
                                    NAME: "custom",
                                    VAL: Tokens.FontFamily.bentonSans
                                  }),
                              tl: {
                                hd: Css.fontSize(Css.px(14)),
                                tl: {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                  tl: {
                                    hd: Css.textAlign("left"),
                                    tl: {
                                      hd: Css.whiteSpace("preWrap"),
                                      tl: {
                                        hd: Css.lineHeight(Css.px(20)),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            })
                      }, Curry._2(match.t2, "SelectAccountModal_restrictedAuction", {
                            saleStartOrClose: props.auctionType === "Live" ? Curry._1(t, "SelectAccountModal_saleStart") : Curry._1(t, "Common_close")
                          }))
                }));
}

var RestrictedAuctionNotification = {
  make: AuctionEnrollmentModal$RestrictedAuctionNotification
};

function AuctionEnrollmentModal$ModalContent(props) {
  var saleNumber = props.saleNumber;
  var nextStep = props.nextStep;
  var onClose = props.onClose;
  var auctionId = props.auctionId;
  var apolloClient = props.apolloClient;
  var fragment = props.fragment;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = Curry.app(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.SetAgreementStatusMutation.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var setAgreementStatus = match$1[0];
  var match$2 = React.useReducer((function (state, action) {
          switch (action.TAG | 0) {
            case /* ConditionsOfSaleChecked */0 :
                return {
                        conditionsOfSaleChecked: action._0,
                        purchasingForCheck: state.purchasingForCheck,
                        selectedAccountId: state.selectedAccountId,
                        agreementStatuses: state.agreementStatuses
                      };
            case /* PurchasingForCheck */1 :
                return {
                        conditionsOfSaleChecked: state.conditionsOfSaleChecked,
                        purchasingForCheck: [
                          action._0,
                          action._1
                        ],
                        selectedAccountId: state.selectedAccountId,
                        agreementStatuses: state.agreementStatuses
                      };
            case /* SetSelectItem */2 :
                return {
                        conditionsOfSaleChecked: state.conditionsOfSaleChecked,
                        purchasingForCheck: state.purchasingForCheck,
                        selectedAccountId: action._0,
                        agreementStatuses: state.agreementStatuses
                      };
            case /* UpdateAgreementStatuses */3 :
                return {
                        conditionsOfSaleChecked: state.conditionsOfSaleChecked,
                        purchasingForCheck: state.purchasingForCheck,
                        selectedAccountId: state.selectedAccountId,
                        agreementStatuses: action._0
                      };
            
          }
        }), {
        conditionsOfSaleChecked: false,
        purchasingForCheck: [
          false,
          false
        ],
        selectedAccountId: "",
        agreementStatuses: {}
      });
  var dispatch = match$2[1];
  var state = match$2[0];
  var match$3 = Curry.app(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.RequestToEnrollMutation.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        (function (param) {
            Notification$LiveRoom.showError("EnrollFailed");
            SLI$LiveRoom.send("Bad", undefined, "Register");
          }),
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var enrollmentRes = match$3[1];
  var requestToEnroll = match$3[0];
  React.useEffect((function () {
          var match = enrollmentRes.data;
          if (match !== undefined) {
            var match$1 = match.requestToEnroll.enrollmentResult;
            if (match$1 !== undefined && typeof match$1 === "object") {
              var variant = match$1.NAME;
              if (variant === "EnrollmentAccepted") {
                Curry._2(nextStep, {
                      NAME: "Success",
                      VAL: [
                        state.selectedAccountId,
                        match$1.VAL.paddleId
                      ]
                    }, false);
                SLI$LiveRoom.send("Good", undefined, "Register");
              } else if (variant === "EnrollmentUpForReview") {
                var isAgent = Caml_obj.equal(match$1.VAL.enrollmentUpForReviewReason, "IdAgentException");
                Curry._2(nextStep, "Failure", isAgent);
                SLI$LiveRoom.send("Good", undefined, "Register");
              }
              
            }
            
          }
          
        }), [enrollmentRes.data]);
  var onConfirm = function (param) {
    var saleLocation = Belt_Option.flatMap(fragment.location, (function ($$location) {
            return AuctionRoomSharedContacts$LiveRoom.auctionLocationToSaleLocation(AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType($$location.name));
          }));
    Utils_AutochargeRestriction$LiveRoom.checkForAutochargePaymentMethod(auctionId, state.selectedAccountId, saleLocation, apolloClient, (function (param) {
            Curry._8(requestToEnroll, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Curry._5(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.RequestToEnrollMutation.makeVariables, auctionId, state.selectedAccountId, "Online", state.purchasingForCheck[0], undefined));
            Belt_Array.forEach(Js_dict.entries(state.agreementStatuses), (function (param) {
                    Curry._8(setAgreementStatus, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                          agreementId: param[0],
                          accepted: param[1]
                        });
                  }));
          }), (function (param) {
            AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                  origin: /* SaleRegistration */1,
                  saleNumber: saleNumber,
                  saleLocation: Belt_Option.map(saleLocation, AuctionRoomSharedContacts$LiveRoom.saleLocationToJs),
                  accountId: state.selectedAccountId
                }, {
                  accountId: state.selectedAccountId,
                  bidOnBehalf: state.purchasingForCheck[0],
                  agreementStatuses: Caml_option.some(state.agreementStatuses)
                }, Config$LiveRoom.values.transactionlUrl);
          }));
  };
  var tmp;
  if (Belt_Option.isSome(fragment.enrollment.restrictedDate)) {
    var match$4 = fragment.type;
    tmp = React.createElement(AuctionEnrollmentModal$RestrictedAuctionNotification, {
          auctionType: match$4 === "Timed" ? "Timed" : "Live"
        });
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                    hd: Css.width(Css.pct(100)),
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            })
                      }, React.createElement(PropSpread$LiveRoom.make, {
                            data: {
                              hd: {
                                TAG: /* TestId */1,
                                _0: "selectAccountText"
                              },
                              tl: /* [] */0
                            },
                            children: React.createElement("p", {
                                  className: subHeader
                                }, React.createElement(ReactI18next.Trans, {
                                      t: t,
                                      i18nKey: "SelectAccountModal_selectWhichAccount",
                                      components: [React.createElement("span", {
                                              className: Curry._1(Css.style, {
                                                    hd: Css.fontWeight({
                                                          NAME: "num",
                                                          VAL: Caml_format.int_of_string(Tokens.Typography.bentonSansSelectionMWeight)
                                                        }),
                                                    tl: /* [] */0
                                                  })
                                            })]
                                    }))
                          }), tmp, React.createElement(SelectAccount$LiveRoom.make, {
                            onAccountSelected: (function (item) {
                                Curry._1(dispatch, {
                                      TAG: /* SetSelectItem */2,
                                      _0: item
                                    });
                              }),
                            auctionLocation: Belt_Option.mapWithDefault(fragment.location, "", (function (x) {
                                    return String(x.name);
                                  })),
                            onCheckboxChanged: (function (checked) {
                                Curry._1(dispatch, {
                                      TAG: /* ConditionsOfSaleChecked */0,
                                      _0: checked
                                    });
                              }),
                            conditionOfSaleText: Belt_Option.mapWithDefault(fragment.conditionsOfSale, "", (function (conditions) {
                                    return Belt_Option.getWithDefault(Js_json.decodeString(conditions), "");
                                  })),
                            conditionsOfSaleChecked: state.conditionsOfSaleChecked,
                            onRadioButtonPurchasingForChanged: (function (checkedAgent, checkedMe) {
                                Curry._1(dispatch, {
                                      TAG: /* PurchasingForCheck */1,
                                      _0: checkedAgent,
                                      _1: checkedMe
                                    });
                              }),
                            purchasingForCheckState: state.purchasingForCheck,
                            agreements: fragment.agreementsFragment.agreements,
                            agreementStatuses: state.agreementStatuses,
                            onUpdateAgreementStatuses: (function (statuses) {
                                Curry._1(dispatch, {
                                      TAG: /* UpdateAgreementStatuses */3,
                                      _0: statuses
                                    });
                              }),
                            additionalStyles: {
                              hd: Css.width(Css.pct(100)),
                              tl: /* [] */0
                            }
                          })),
                  className: modalContainer
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: null,
                  className: Curry._1(Css.style, {
                        hd: Css.important(Css.padding3("zero", Css.px(40), Css.px(40))),
                        tl: /* [] */0
                      })
                }, React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "selectAccountCancelButton"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(Button.Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            className: Curry._1(Css.style, {
                                  hd: Css.important(Css.width(Css.px(144))),
                                  tl: /* [] */0
                                }),
                            buttonStyle: "secondary",
                            children: Curry._1(t, "SelectAccountModal_cancel")
                          })
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "SelectAccountEnrollButton"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(Button.Button, {
                            onClick: onConfirm,
                            className: Curry._1(Css.style, {
                                  hd: Css.marginLeft(Css.px(16)),
                                  tl: {
                                    hd: Css.important(Css.width(Css.px(264))),
                                    tl: /* [] */0
                                  }
                                }),
                            disabled: !state.conditionsOfSaleChecked || state.selectedAccountId === "" || !(state.purchasingForCheck[0] || state.purchasingForCheck[1]),
                            loading: enrollmentRes.loading,
                            children: Curry._1(t, "SelectAccountModal_confirmChosenAccount")
                          })
                    })));
}

var ModalContent = {
  make: AuctionEnrollmentModal$ModalContent
};

function AuctionEnrollmentModal(props) {
  var onClose = props.onClose;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient(undefined);
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: React.createElement(AuctionEnrollmentModal$ModalContent, {
                    fragment: props.fragment,
                    apolloClient: apolloClient,
                    auctionId: props.auctionId,
                    onClose: onClose,
                    nextStep: props.nextStep,
                    saleNumber: props.saleNumber
                  }),
              className: Curry._1(Css.style, {
                    hd: Css.important(Css.maxHeight(Css.pct(100))),
                    tl: {
                      hd: Css.important(Css.maxWidth(Css.px(724))),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                              hd: Css.important(Css.maxWidth(Css.unset)),
                              tl: {
                                hd: Css.height(Css.pct(100)),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              headerClassName: Curry._1(Css.style, {
                    hd: Css.important(Css.padding3(Css.px(20), Css.px(40), "zero")),
                    tl: /* [] */0
                  }),
              onClose: (function (param) {
                  Curry._1(onClose, undefined);
                }),
              isOpen: true,
              headerTitle: Curry._1(match.t, "AuctionRoomPage_selectYourAccount")
            });
}

var AgreementsFragment = ClientapiQueries$LiveRoom.AuctionEnrollmentModal.AgreementsFragment;

var AuctionEnrollmentModalFragment = ClientapiQueries$LiveRoom.AuctionEnrollmentModal.AuctionEnrollmentModalFragment;

var RequestToEnrollMutation = ClientapiQueries$LiveRoom.AuctionEnrollmentModal.RequestToEnrollMutation;

var SetAgreementStatusMutation = ClientapiQueries$LiveRoom.AuctionEnrollmentModal.SetAgreementStatusMutation;

var make = AuctionEnrollmentModal;

export {
  AgreementsFragment ,
  AuctionEnrollmentModalFragment ,
  RequestToEnrollMutation ,
  SetAgreementStatusMutation ,
  modalContainer ,
  subHeader ,
  RestrictedAuctionNotification ,
  ModalContent ,
  make ,
}
/* modalContainer Not a pure module */
